import { RaceMatrixTable } from '../../../components/RaceMatrixTable';
import { useRaceModelMatrix } from '../../../queries/meetingAnalysis';

interface RaceMatrixViewProps {
  meetingId: string;
}

export function RaceMatrixView({ meetingId }: RaceMatrixViewProps) {
  const { data: matrix, isLoading } = useRaceModelMatrix(meetingId);

  if (isLoading) {
    return <div className="py-8 text-center text-muted-foreground">Loading matrix…</div>;
  }

  if (!matrix || matrix.slots.length === 0) {
    return <div className="py-8 text-center text-muted-foreground">No analysis yet for this meeting.</div>;
  }

  return <RaceMatrixTable data={matrix} />;
}
